import { IconButton, Popover, Tooltip, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import {
  bindPopover,
  bindTrigger,
  usePopupState,
} from 'material-ui-popup-state/hooks';
import Iconify from 'src/components/iconify';
import { useLocales } from 'src/locales';
import { useLivekitRTCState } from 'src/provider/VoiceChannel/livekit/useLivekitRTCState';
import { ToggleAudioNoiseFilter } from './ToggleAudioNoiseFilter';

export const AudioNoiseFilterPopover = () => {
  const { translate } = useLocales();

  const { noiseFilter } = useLivekitRTCState();

  const popupState = usePopupState({
    variant: 'popover',
    popupId: 'audioNoiseFilter',
  });

  return (
    <>
      <Tooltip title="Toogle Noise Filter" placement="top" arrow>
        <IconButton {...bindTrigger(popupState)}>
          <Iconify
            icon="lucide:audio-lines"
            color={noiseFilter ? 'success.main' : 'inherit'}
          />
        </IconButton>
      </Tooltip>
      <Popover
        {...bindPopover(popupState)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <Stack sx={{ p: 1, gap: 1, maxWidth: 300 }}>
          <ToggleAudioNoiseFilter />
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ px: 2, pb: 1 }}
          >
            {translate('communicate.rtc_controls.noise_filter_details')}
          </Typography>
        </Stack>
      </Popover>
    </>
  );
};
